import React, {useState} from 'react';

import ChipSelectInput from 'ui-library/inputs/ChipSelectInput';
import {OptionValue} from 'ui-library/menus/MenuConstants';
import {getMatchingOptionDatas} from 'ui-library/menus/MenuUtil';

import LabelWrapper from '../shared/LabelWrapper';
import * as uiBlock from '../UiBlockTypes';

interface SelectorInputUiBlockProps extends uiBlock.SelectorInput {
  onChangeValue: (blockId: string, val: string | null) => void;
}

function SelectorInputUiBlock({
  value,
  options,
  onChangeValue,
  id,
  enabled,
  canvasEnabled,
  label,
}: SelectorInputUiBlockProps): JSX.Element {
  const [query, setQuery] = useState('');

  const canEdit = canvasEnabled && enabled;

  const handleRemove = (_?: OptionValue): void => {
    onChangeValue(id, null);
  };
  const handleSelect = (newValue: OptionValue): void => {
    if (newValue === value) {
      handleRemove();
    } else {
      onChangeValue(id, newValue);
    }
    setQuery('');
  };

  return (
    <div>
      <LabelWrapper label={label} />
      <ChipSelectInput
        autoFocus={false}
        scrollable={true}
        optionDatas={getMatchingOptionDatas(
          query,
          options.map((o) => ({name: o, value: o}))
        )}
        placeholder="Select..."
        value={value ? [value] : []}
        query={query}
        onQueryChange={(q) => {
          setQuery(q.target.value);
        }}
        isMulti={false}
        disabled={!canEdit}
        onSelect={handleSelect}
        onRemove={handleRemove}
      />
    </div>
  );
}

export default SelectorInputUiBlock;
